import axios from "../utils/axios";
import { ApiInterface } from "./api.interface";

class QuestsApi extends ApiInterface {
  constructor() {
    super("quests-tracker");
  }

  public async claimReward(id: string): Promise<void> {
    return await axios.post(`${this.rootEndpoint}/${id}/claim`);
  }
}

export const questsApi = new QuestsApi();
